import { NavMarker } from 'react-rhumb';
import LoginForm from './LoginForm';
import MarketingCta from './MarketingCta';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { MarketingCtaFormWrapper, ExtraCtaBackground } from './MarketingCta.styles';
// @ts-expect-error not converted to TS
import Image from '../../images/imageUrls.js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLandingExtraCta = ({
  allowFbSignup,
  signupParams,
  loginRedirectUrl,
  loginSubmit,
  googleLoginClick,
  ssoLoginClick,
  isInvalidTokenAlertVisible,
  pageId
}) => {
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "LOGIN_LOAD",
    children: [/*#__PURE__*/_jsx(ExtraCtaBackground, {}), /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      justify: "center",
      direction: "column",
      className: "p-top-5",
      children: [/*#__PURE__*/_jsx(UIImage, {
        src: Image.hubspotLogo,
        width: 200,
        alt: "Hubspot Logo",
        className: "m-bottom-6"
      }), /*#__PURE__*/_jsxs(MarketingCtaFormWrapper, {
        children: [/*#__PURE__*/_jsx(LoginForm
        // @ts-expect-error ts-migrate - clash between functional and class components
        , {
          onLoginSubmit: loginSubmit,
          onGoogleLoginClick: googleLoginClick,
          onSsoLoginClick: ssoLoginClick,
          isInvalidTokenAlertVisible: isInvalidTokenAlertVisible,
          loginRedirectUrl: loginRedirectUrl,
          variant: "marketing"
        }), /*#__PURE__*/_jsx(H5, {
          className: "text-center m-bottom-2 m-top-4 p-left-6 p-right-6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.marketingCopy.createAccount"
          })
        }), /*#__PURE__*/_jsx(MarketingCta, {
          allowFbSignup: allowFbSignup
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | string[]' is not assignable to type... Remove this comment to see the full error message
          ,
          signupParams: signupParams,
          loginRedirectUrl: loginRedirectUrl,
          pageId: pageId
        })]
      })]
    })]
  });
};
export default LoginLandingExtraCta;